import React from "react";

const ArrowLeft = () => (
<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.85352 10.707L1.99976 5.85328L6.85352 0.999527" stroke="#00F37A" strokeWidth="1.5"/>
<path d="M3.18198 5.85157L13.5 5.85156" stroke="#00F37A" strokeWidth="1.5"/>
</svg>
);

export default ArrowLeft;
